<template>
  <div
    class="m-dropdown__content"
    :class="{
      'm-dropdown__content--left': align === 'left',
      'm-dropdown__content--right': align === 'right',
      'm-dropdown__content--top-left': align === 'top-left',
      'm-dropdown__content--top-right': align === 'top-right',
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MDropdownContent',
  props: {
    align: {
      type: String,
      default: 'left',
    },
  },
}
</script>

<style lang="scss" scoped>
.m-dropdown__content {
  background: var(--skin-background-light);
  border: 0 none;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-low);
  display: grid;
  left: 0;
  min-width: 8em;
  opacity: 1;
  padding: var(--spacing-16) 0;
  position: absolute;
  top: 100%;
  transform: none;
  z-index: 1;

  &.slide-down {
    &-enter-from,
    &-leave-to {
      opacity: 0;
      transform: translateY(-0.5em);
    }

    &-enter-active,
    &-leave-active {
      transition:
        transform var(--animation),
        opacity var(--animation);
    }
  }

  &--left {
    left: 0;
    right: auto;
  }

  &--right {
    left: auto;
    right: 0;
  }

  &--top-left {
    left: auto;
    right: 100%;
    top: 0;
  }

  &--top-right {
    left: 100%;
    right: auto;
    top: 0;
  }
}
</style>
